export default class Navigation {

    setLastSimulation(registration, simulation) {
        Vue.prototype.$auth.setUiConfig({ registration, simulation }, 'last_simulation')
    }

    getLastSimulation() {
        return Vue.prototype.$auth.getUiConfig('last_simulation')
    }
}
